module.exports = __webpack_public_path__ + "img/dar-image.31a26f31.jpg";